import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
// import Select from 'react-select';
import _ from 'lodash';
import queryString from 'query-string';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { get, getJson } from 'session';
import Pagination from 'modules/common/components/Pagination';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
// import moment from 'moment';
import { numberWithCommas } from 'helper';
import moment from 'moment';
import * as actions from '../actions';
import * as c from '../constants';
import history from '../../../../history';

const FireSafetyReports = ({ getFireList, list, isLoading, pager }) => {
  // const query = queryString.parse(window.location.search);
  const token = get('token') || '';
  const authProfile = getJson('profile') || {};
  const [formData, setFormData] = useState({
    date_from: '',
    date_to: '',
  });
  const [date, setDate] = useState({ date_from: '', date_to: '' });
  const syncFilters = (params) => {
    return history.replace({
      pathname: window.location.pathname,
      search: queryString.stringify(params),
    });
  };

  const handleDateChange =
    (key) =>
    ({ target: { value } }) => {
      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const handleChangePage = (page) => {
    getFireList({
      ...formData,
      ...date,
      page,
    });
    syncFilters({ ...formData, page });
  };
  // };

  useEffect(() => {
    getFireList({
      ...formData,
    });
  }, []);

  const onSearch = (e) => {
    e.preventDefault();
    getFireList({
      ...formData,
      date_from: _.get(formData, 'date_from')
        ? `${moment(_.get(formData, 'date_from')).format(
            'YYYY-MM-DD HH:mm'
          )}:00`
        : '',
      date_to: _.get(formData, 'date_to')
        ? `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')} 23:59:00`
        : '',
    });

    setDate({
      date_from: _.get(formData, 'date_from')
        ? `${moment(_.get(formData, 'date_from')).format(
            'YYYY-MM-DD HH:mm'
          )}:00`
        : '',
      date_to: _.get(formData, 'date_to')
        ? `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')} 23:59:00`
        : '',
    });
  };

  const onClear = (e) => {
    e.preventDefault();
    setFormData({
      date_from: '',
      date_to: '',
    });
    setDate({ date_from: '', date_to: '' });
    syncFilters({
      date_from: '',
      date_to: '',
    });
    getFireList({});
    history.replace({ pathname: window.location.pathname });
  };

  const getFireReports = () => {
    const path = `${process.env.REACT_APP_WS}api/v1/bpls/administrator/report/fire_safety/export`;
    const params = queryString.stringify({
      ...queryString.parse(window.location.search),
      ...date,
      bearer_token: token,
      email: _.get(authProfile, 'email'),
    });
    return `${path}?${params}`;
  };

  const renderAmount = (value) => {
    return value ? (
      <>
        <b className="d-inline">PHP&nbsp;</b>{' '}
        <inline>{numberWithCommas(value?.toFixed(2))}</inline>
      </>
    ) : (
      '---'
    );
  };

  return (
    <div className="module-inner">
      <div className="report-module-nav mb-3">
        <div className="col-12">
          <form onSubmit={onSearch}>
            <div className="row mt-2">
              {/* <div className="col-3">
                <div className="form-group">
                  <label className="label-reports">Registration Status</label>
                  <Select
                    name="registration_status"
                    placeholder="Select Status"
                    onChange={handleChangeSelect('registration_status')}
                    options={selectOptions}
                    value={
                      query.registration_status
                        ? {
                            value: query.registration_status,
                            label: query.registration_status,
                          }
                        : { value: '', label: 'ALL' }
                    }
                  />
                </div>
              </div> */}
              <div className="form-input-group col-3">
                <label className="label-reports">Date From</label>
                <DateInputPicker
                  className="full-input"
                  onChange={handleDateChange('date_from')}
                  value={_.get(formData, 'date_from') || ''}
                />
              </div>
              <div className="form-input-group col-3">
                <label className="label-reports">Date To</label>
                <DateInputPicker
                  className="full-input"
                  onChange={handleDateChange('date_to')}
                  value={_.get(formData, 'date_to') || ''}
                />
              </div>
              {/* <div className="col-3 pr-0">
                <div className="form-group">
                  <label className="label-reports">BIN</label>
                  <input
                    className="form-control"
                    name="bin"
                    onChange={onChange}
                    value={query.bin || ''}
                  />
                </div>
              </div> */}
            </div>
            <div className="row mt-3">
              <div className="col-6 pr-0">
                <div className="form-group">
                  <button
                    onClick={onClear}
                    type="button"
                    className="btn btn-link button-black py-2"
                  >
                    <i className="fas fa-times" /> &nbsp;&nbsp; Clear
                  </button>
                  &nbsp;
                  <button
                    type="submit"
                    className="btn btn-md btn-primary cms-bg-color-primary mt-0 py-2"
                  >
                    <i className="fas fa-filter" /> &nbsp;&nbsp;Filter
                  </button>
                </div>
              </div>
              <div className="col-6 pr-0 d-flex ml-auto pr-3">
                <div className="ml-auto">
                  <div className="">
                    <a
                      href={getFireReports()}
                      className="btn btn-md btn-primary cms-bg-color-primary cms-outline-primary "
                      style={{ color: 'white' }}
                    >
                      <i className="fas fa-cloud-download-alt mr-2" />
                      Download
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div className="row pr-3 py-2 mb-2">
            <div className="ml-3">
              <div className="form-group">
                <label className="label-reports">
                  Total Registered: &nbsp;
                </label>
                <input name="q" disabled value={_.get(pager, 'total') || ''} />
              </div>
            </div>
          </div>
          {isLoading ? (
            <div
              className="loading d-flex text-center justify-content-center align-items-center"
              style={{ height: '500px' }}
            >
              <div className="spinner text-center ">
                <span className="fas fa-5x fa-spin fa-spinner" />
              </div>
            </div>
          ) : (
            <div className="table-responsive">
              <table
                className="table table-striped table-sm table-bordered table-hover"
                style={{ width: '250%' }}
              >
                <thead className="table-header text-center">
                  <tr>
                    <th style={{ width: '5%' }}>BIN</th>
                    <th>Business Name</th>
                    <th>Owner&apos;s Name / Location</th>
                    <th>Mayor&apos;s Permit Fee</th>
                    <th style={{ width: '5%' }}>Garbage Fee</th>
                    <th style={{ width: '5%' }}>Sanitary Inspection Fee</th>
                    <th style={{ width: '5%' }}>Building Inspection Fee</th>
                    <th>Mechanical Inspection Fee</th>
                    <th style={{ width: '5%' }}>Plumbing Inspection Fee</th>
                    <th style={{ width: '5%' }}>Electrical Inspection Fee</th>
                    <th>Signboard Inspection Fee</th>
                    <th style={{ width: '5%' }}>Registration Plate Fee</th>
                    <th style={{ width: '5%' }}>Signboard Permit Fee</th>
                    <th>Total</th>
                    <th>E-OR No.</th>
                    <th>Fire Safety Inspection Fee</th>
                    <th>Payment Date</th>
                  </tr>
                </thead>
                <tbody className="table-details">
                  {list.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{_.get(item, 'attributes.bin') || '---'}</td>
                        <td className="text-capitalize">
                          {_.get(
                            item,
                            'attributes.business_name'
                          ).toLowerCase() || '---'}
                        </td>
                        <td className="text-capitalize">
                          <div
                            className="text-capitalize"
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{
                              __html:
                                _.get(item, 'attributes.location_full_name')
                                  ?.replace(/\n/g, '<br />')
                                  .toLowerCase() || '',
                            }}
                          />
                        </td>
                        <td>
                          {renderAmount(_.get(item, 'attributes.mayors_fee'))}
                        </td>
                        <td>
                          {renderAmount(_.get(item, 'attributes.garbage_fee'))}
                        </td>
                        <td>
                          {renderAmount(
                            _.get(item, 'attributes.sanitary_insp_fee')
                          )}
                        </td>
                        <td>
                          {renderAmount(
                            _.get(item, 'attributes.building_insp_fee')
                          )}
                        </td>
                        <td>
                          {renderAmount(
                            _.get(item, 'attributes.mechanical_insp_fee')
                          )}
                        </td>
                        <td>
                          {renderAmount(
                            _.get(item, 'attributes.plumbing_insp_fee')
                          )}
                        </td>
                        <td>
                          {renderAmount(
                            _.get(item, 'attributes.electrical_insp_fee')
                          )}
                        </td>
                        <td>
                          {renderAmount(
                            _.get(item, 'attributes.signboard_insp_fee')
                          )}
                        </td>
                        <td>
                          {renderAmount(
                            _.get(item, 'attributes.registration_plate_fee')
                          )}
                        </td>
                        <td>
                          {renderAmount(
                            _.get(item, 'attributes.signboard_permit_fee')
                          )}
                        </td>
                        <td>{renderAmount(_.get(item, 'attributes.total'))}</td>
                        <td>{_.get(item, 'attributes.e_or_no') || ''}</td>
                        <td>
                          {renderAmount(
                            _.get(item, 'attributes.fire_safety_fee')
                          )}
                        </td>
                        <td>
                          {moment(
                            `${_.get(item, 'attributes.paid_at')}`
                          ).format('MMM DD, YYYY') || ''}
                        </td>
                        {/* <td>
                          {_.get(item, 'attributes.kind_of_ownership') || '---'}
                        </td>
                        <td>
                          {_.get(item, 'attributes.cellphone_no') || '---'}
                        </td>

                        <td>
                          {_.get(item, 'attributes.telephone_no') || '---'}
                        </td>
                        <td>
                          {_.get(item, 'attributes.email_address') || '---'}
                        </td>
                        <td>{_.get(item, 'attributes.sec_no') || '---'}</td>
                        <td>{_.get(item, 'attributes.tin_no') || '---'}</td>
                        <td>{_.get(item, 'attributes.dti_no') || '---'}</td>
                        <td>
                          {_.get(item, 'attributes.display_address') || '---'}
                        </td>
                        <td>
                          {_.get(
                            item,
                            'included.taxPayer.attributes.display_name'
                          ) || '---'}
                        </td>
                        <td>
                          {_.get(
                            item,
                            'included.taxPayer.attributes.mobile_number'
                          ) || '---'}
                        </td>
                        <td>
                          {_.get(
                            item,
                            'attributes.terms_and_conditions_pre_registration'
                          )
                            ? 'COMPLETED'
                            : 'PENDING'}
                        </td>
                        <td>
                          {_.get(item, 'attributes.date') ||
                            '---'}
                        </td> */}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          <div className="list-pagination">
            {pager.total_pages > 1 ? (
              <div className="d-flex justify-content-center text-center align-item-center">
                <Pagination data={pager} onChange={handleChangePage} />
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

FireSafetyReports.propTypes = {
  getFireList: PropTypes.instanceOf(Function).isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  isLoading: PropTypes.bool.isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  list: _.get(api, `${c.FIRE_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.FIRE_LIST) > -1,
  pager: _.get(api, `${c.FIRE_LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(FireSafetyReports);
